// extracted by mini-css-extract-plugin
export default {"root":"XAHAdhyqDSkFxzZPUSPZ","roundTop":"mmbULccXrmhn3FQYSAsw","roundBottom":"kxOVoKdZAEM8oBpsRzsA","titleOpt":"pZv1R2nS7ej9wiSaOJDx","placeHolderShimmer":"PzROjbNPB4czvxxEQpVm"};